export default {
  create_title: 'Webhook-Endpunkt hinzufügen',
  edit_title: 'Webhook-Endpunkt bearbeiten',
  form: {
    url: 'HTTPS-Endpunkt-URL',
    description: 'Beschreibung',
    description_placeholder: 'z. B. Bestellereignisse für das Kassensystem',
    events: 'Zuzustellende Ereignisse',
    events_required: 'Wählen Sie mindestens ein Ereignis aus.',
    events_hint: 'Nur die ausgewählten Ereignisse werden an diesen Endpunkt gesendet.',
    events_selected: '{{selected}} von {{total}}',
    event_groups: {
      order: 'Bestellungen',
      store: 'Filiale',
      product: 'Produkte',
      modifier: 'Optionen',
      menu_push: 'Menü-Übertragungen',
      payout: 'Auszahlungen',
    },
    status: 'Status',
    status_active: 'Aktiv',
    status_disabled: 'Deaktiviert',
    status_auto_disabled: 'Automatisch deaktiviert (Aktiv wählen zum Reaktivieren)',
  },
  buttons: {
    cancel: 'Abbrechen',
    create: 'Erstellen',
    save: 'Speichern',
  },
  toasts: {
    created: 'Endpunkt erstellt.',
    updated: 'Endpunkt aktualisiert.',
    error: 'Der Endpunkt konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  },
};
